import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SparkLogo from './SparkLogo';

const ProtectedRoute = ({ children, requireOnboarded = true }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();
  const [profileWaitElapsed, setProfileWaitElapsed] = useState(false);

  // Safety net: se o profile demorar mais de 3.5s pra carregar após o user existir,
  // libera a UI assumindo que o estado atual é o estado real
  useEffect(() => {
    if (!user || profile) return;
    const t = setTimeout(() => setProfileWaitElapsed(true), 3500);
    return () => clearTimeout(t);
  }, [user, profile]);

  // 1. Auth context ainda inicializando (getSession): mostra splash
  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#050816]"
        data-testid="protected-route-loading"
      >
        <div className="flex flex-col items-center gap-4">
          <SparkLogo height={48} />
          <div className="flex items-center gap-2 text-xs text-slate-400">
            <div className="w-2 h-2 rounded-full bg-[#4facfe] animate-pulse" />
            Carregando sua Spark...
          </div>
        </div>
      </div>
    );
  }

  // 2. Sem user → manda pra /auth
  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }

  // 3. Tem user mas profile ainda não chegou: pequena espera, depois libera
  if (!profile && !profileWaitElapsed) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#050816]"
        data-testid="protected-route-profile-loading"
      >
        <div className="flex flex-col items-center gap-4">
          <SparkLogo height={48} />
          <div className="flex items-center gap-2 text-xs text-slate-400">
            <div className="w-2 h-2 rounded-full bg-[#ffa726] animate-pulse" />
            Preparando seu perfil...
          </div>
        </div>
      </div>
    );
  }

  // 4. Se profile carregou e não está onboarded, força /onboarding
  if (requireOnboarded && profile && !profile.onboarded && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default ProtectedRoute;
